import { URLS } from "utils/constants";

// Agent Rank Components
import AgentRankBoard from "pages/agent-rank/AgentRankBoard";
import AgentRankReward from "pages/agent-rank/AgentRankReward";
import AgentRewardCRUD from "pages/agent-rank/AgentRewardCRUD";
import AgentRankPenalty from "pages/agent-rank/AgentRankPenalty";
import AgentRankSetting from "pages/agent-rank/AgentRankSetting";

import { TierProvider } from "pages/agent-rank/context/TierContext";
import { SeasonProvider } from "pages/agent-rank/context/SeasonContext";
import { AgentRewardProvider } from "pages/agent-rank/context/AgentRewardContext";

export const agentRankRoutes = [
  {
    path: URLS.v1.AGENTRANK,
    element: (
      <TierProvider>
        <AgentRankBoard />
      </TierProvider>
    ),
  },
  {
    path: URLS.v1.AGENTRANK_REWARD,
    element: <AgentRankReward />,
  },
  {
    path: URLS.v1.AGENTRANK_REWARD_CRUD,
    element: (
      <AgentRewardProvider>
        <AgentRewardCRUD />
      </AgentRewardProvider>
    ),
  },
  {
    path: URLS.v1.AGENTRANK_PINALTY,
    element: <AgentRankPenalty />,
  },
  {
    path: URLS.v1.AGENTRANK_SETTING,
    element: (
      <TierProvider>
        <SeasonProvider>
          <AgentRankSetting />
        </SeasonProvider>
      </TierProvider>
    ),
  },
];
